import axios from "axios";
import React, { FC, useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import eye from "../../../assets/img/icons/eye-solid.svg"
import profileIcon from "../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg"
import "../userInfo/Users.css";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { IUser, IWorker, IWorkerRatings } from "src/helper/interfaces";
import moment from "moment-timezone";
import { IServiceOrder } from "src/helper/interfaces";
import Cookies from "js-cookie";
import Select from "react-select";
import { formatCategory, formatDiffrentDate } from "src/utils/normalFuntions";
import Paginator from "src/components/layout/Paginator";
import bill from "../../../assets/img/icons/marketing-bill-payment-invoice-receipt-svgrepo-com.svg";
import LoadingGif from "src/components/layout/Loader";
import { useBackContext } from "src/hooks/context/BackContext";
import permanentAddress from "../../../assets/img/icons/address-permanent.svg";
import currentAddress from "../../../assets/img/icons/address-current.svg";
import { TreeNode } from 'primereact/treenode';
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import ExportDocs from "src/components/layout/ExportDocs";
import StarRating from "src/components/layout/StarRating";
import { getWorkerRatings } from "../workers/Workers";
import { Link } from "react-router-dom";
import CheckboxFilter from "src/components/layout/CheckboxFilter";
const getAllOrders = async (
   token: string, pageNumber: number,
   pageSize: number, searchValue: string,
   startDate?: string, endDate?: string,
   orderStatus?: string[], orderType?: string[]

) => {

   return await axios.get(`${AppConfig.DEV_SERVER}/doorstep-orders`, {
      headers: {
         "x-access-token": token
      },
      params: {
         page: pageNumber,
         search_value: searchValue,
         pageSize,
         start_date: startDate,
         end_date: endDate,
         order_status: orderStatus,
         order_type: orderType
      }
   })
};

const getAllWorkers = async (token: string, searchValue: string, category: string[]) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/all-workers`, {
      headers: {
         "x-access-token": token
      },
      params: {
         search_value: searchValue,
         pageSize: 20,
         category: category
      }
   })
};

type checkboxFilters = {
   orderType: string[],
   orderStatus: string[],
}

const DoorstepOrders = () => {

   const initialValues: IServiceOrder = {

      _id: "",
      assigned_worker: "",
      billing_details: {
         service_charges: 0,
         convenience_charges: 0,
         tax: 0,
         total_amount: 0,
         additional_working_charges: 0,
         additional_working_mins: 0,

         yows_comm_inc_gst: 0,
         yows_comm_exc_gst: 0,
         worker_comm: 0,
         gst_on_worker_comm: 0,
         gst_on_yows_comm: 0,
         tcs_amt: 0,

         add_gst_on_worker_comm: 0,
         add_gst_on_yows_comm: 0,
         add_tcs_amt: 0,
         add_worker_comm: 0,
         add_yows_comm_exc_gst: 0,
         add_yows_comm_inc_gst: 0,
      },
      createdAt: "",
      date_time: "",
      end_time: "",
      order_type: "",
      otp: "",
      payment_id: "",
      payment_order_id: "",
      service_category: "",
      service_id: "",
      service_count: 0,
      service_providers: [],
      service_title: "",
      user_id: "",
      unique_id: "",
      serviceDetails: {
         title: "",
         price_per_half_hour: 0,
         price_per_hour: 0,
         service_image: "",
         price: 0,
      },
      start_time: "",
      status: "",
      unique_code: "",
      updatedAt: "",
      sub_type: [],
      userDetails: {
         name: "",
         phone: "",
         profile_pic: "",

      },
      workerDetails: {
         name: "",
         phone: "",
         profile_pic: "",
         worker_type: "",
         is_verified: false
      },
      address: {
         street: "",
         country: "",
         state: "",
         city: "",
         lat: 0,
         long: 0,
         pin_code: "",

      },
      __v: 0,
      payment_status: false
   };

   const [searchVal, setSearchVal] = useState("");
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);
   const Token = Cookies.get('token');
   const [orders, setOrders] = useState<IServiceOrder[]>([])
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);
   const [startDate, setStartDate] = useState<Date | undefined>(undefined);
   const [endDate, setEndDate] = useState<Date | undefined>(undefined);
   const [checkboxFilters, setCheckBoxFilter] = useState<checkboxFilters>({
      orderType: [],
      orderStatus: [],
   });

   const startingDate = startDate ? startDate.toISOString() : undefined;
   const endingDate = endDate ? endDate.toISOString() : undefined;
   // const [pdf, setPdf] = useState("");
   useEffect(() => {
      dispatch(startLoading());
      getAllOrders(Token as string, pageNo, pageSize, searchVal, startingDate, endingDate, checkboxFilters?.orderStatus, checkboxFilters?.orderType).then((res) => {
         // console.log(res)
         if (res?.data?.status_code === 200) {
            setOrders(res?.data?.data?.data);
            setTotalPages(res?.data?.data?.totalPages);
            dispatch(stopLoading());
         } else {
            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: `${res?.data?.data?.msg}`,
               // footer: '<a href="#">Why do I have this issue?</a>'
            });
         }
      }).catch((err) => {
         console.log(err);
         throw err;
      })
   }, [Token, pageNo, pageSize, searchVal, startDate, endDate, checkboxFilters?.orderStatus, checkboxFilters?.orderType])



   const handleInvoiceClick = async (id: string, order_type: string) => {
      if (!id) return;
      dispatch(startLoading());
      try {
         const res = await axios.get(`${AppConfig.DEV_SERVER}/invoice/${id}`, {
            headers: {
               "x-access-token": Token,
            },
            params: {
               type: order_type,
            },
         });
         // console.log(res)
         if (res?.data?.status_code === 200) {
            dispatch(stopLoading());
            const pdfUrl = res?.data?.data?.file;
            // setPdf(pdfUrl);
            window.open(pdfUrl, "_blank"); // Open the PDF in a new tab
         } else {
            dispatch(stopLoading());
            Swal.fire({
               icon: "error",
               title: "Something Went Wrong...",
               text: `${res?.data?.msg}`,
            });
         }
      } catch (error) {
         dispatch(stopLoading());
         Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to fetch the invoice.",
         });
      }
   };


   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };

   const handleSelectionChange = (selectedChildren: TreeNode[]) => {
      // console.log("Selected Children in Worker:", selectedChildren);
      const typeArray: string[] = [];
      const statusArray: string[] = [];
      const types = ["Engineer", "Architect", "normal_worker"];
      const status = ["pending", "assigned", "completed"]
      selectedChildren.map((data: TreeNode) => {
         // console.log("data:", data)
         if (status?.includes(data?.data)) {
            statusArray?.push(data?.data)
         }
         else if (types?.includes(data?.data)) {
            typeArray?.push(data?.data)
         }

      });
      setCheckBoxFilter({
         ...checkboxFilters,
         orderStatus: statusArray,
         orderType: typeArray
      })

   };
   const doc = new jsPDF();
   doc.text("Doorstep-Orders-Report", 14, 10);

   const formattedData = orders.map((item) => {
      return {
         order_id: item._id,
         worker_id: item.assigned_worker || "N/A",
         worker_name: item.workerDetails?.name || "N/A",
         worker_phone: item.workerDetails?.phone || "N/A",
         worker_type: item.workerDetails?.worker_type || "N/A",
         user_name: item.userDetails?.name || "N/A",
         user_phone: item.userDetails?.phone || "N/A",
         address: `${item.address?.city}, ${item.address?.state}, ${item.address?.country}, ${item.address?.pin_code}` || "N/A",
         service_title: item.serviceDetails?.title || "N/A",
         service_category: item.service_category || "N/A",
         sub_types: item.sub_type?.join(", ") || "N/A",
         price: item.serviceDetails?.price || "N/A",
         price_per_hour: item.serviceDetails?.price_per_hour || "N/A",
         tax: item.billing_details?.tax || "N/A",
         convenience_charges: item.billing_details?.convenience_charges || "N/A",
         total_amount: item.billing_details?.total_amount || "N/A",
         payment_status: item.payment_status ? "Success" : "Failed",
         date: new Date(item.createdAt).toLocaleDateString(),
         unique_id: item.unique_id || "N/A",
         status: item.status || "N/A",
      };
   });

   const headers = [
      { label: "Order ID", key: "order_id" },
      { label: "Worker ID", key: "worker_id" },
      { label: "Worker Name", key: "worker_name" },
      { label: "Worker Phone", key: "worker_phone" },
      { label: "Worker Type", key: "worker_type" },
      { label: "User Name", key: "user_name" },
      { label: "User Phone", key: "user_phone" },
      { label: "Address", key: "address" },
      { label: "Service Title", key: "service_title" },
      { label: "Service Category", key: "service_category" },
      { label: "Sub Types", key: "sub_types" },
      { label: "Price", key: "price" },
      { label: "Price Per Hour", key: "price_per_hour" },
      { label: "Tax", key: "tax" },
      { label: "Convenience Charges", key: "convenience_charges" },
      { label: "Total Amount", key: "total_amount" },
      { label: "Payment Status", key: "payment_status" },
      { label: "Date", key: "date" },
      { label: "Unique ID", key: "unique_id" },
      { label: "Status", key: "status" },
   ];


   const exportPDF = () => {
      const doc = new jsPDF();

      // Define the columns for the table
      const tableColumns = [
         "Order ID", "Worker ID", "Worker Name", "Worker Phone", "Worker Type",
         "User Name", "User Phone", "Address", "Service Title", "Service Category",
         "Sub Types", "Price", "Price Per Hour", "Tax", "Convenience Charges",
         "Total Amount", "Payment Status", "Date", "Unique ID", "Status"
      ];

      const tableData = formattedData.map((item) => [
         item.order_id,
         item.worker_id,
         item.worker_name,
         item.worker_phone,
         item.worker_type,
         item.user_name,
         item.user_phone,
         item.address,
         item.service_title,
         item.service_category,
         item.sub_types,
         item.price,
         item.price_per_hour,
         item.tax,
         item.convenience_charges,
         item.total_amount,
         item.payment_status,
         item.date,
         item.unique_id,
         item.status
      ]);

      // Use autoTable to generate the table
      autoTable(doc, {
         head: [tableColumns],
         body: tableData,
      });

      // Save the generated PDF
      doc.save('order_report.pdf');
   };


   const handlePageSizeChange = (e: any) => {
      setPageSize(e?.target?.value);
   }
   return (
      <MainLayout
         showAllFilters={false}
         searchValue={searchVal}
         onChange={(e) => setSearchVal(e.target.value)}
         clearValChange={clearSearchValue}
         startDate={startDate}
         onSelectionChange={handleSelectionChange}
         endDate={endDate}
         startDateOnChange={e => setStartDate(e)}
         endDateOnChange={e => setEndDate(e)}
      >

         <div className="main-div">

            <div className={`category-main me-2 p-3 p-md-4 card`} >
               {
                  loading ?
                     <div>
                        <LoadingGif />
                     </div>
                     : ""
               }

                     <div>

                  <div className="d-flex justify-content-end gap-3 mb-3 flex-wrap">
                     <CheckboxFilter onSelectionChange={handleSelectionChange} />
                           <div className="d-flex gap-2">
                              <span className="d-flex align-items-center pagesize-text">
                                 PageSize
                              </span>

                              <select
                                 className="form-select"
                                 style={{ backgroundPosition: "right 5px center", width: "60px" }}
                                 aria-label="Default select example"
                                 value={pageSize} // Bind the value to the state
                                 onChange={handlePageSizeChange} // Handle the change
                              >
                                 <option value={20}>20</option>
                                 <option value={50}>50</option>
                                 <option value={100}>100</option>
                                 <option value={200}>200</option>
                              </select>
                           </div>

                           <ExportDocs headers={headers} formattedData={formattedData} clickHandler={exportPDF} />

                        </div>
                        <div className="table-extra-responsive">
                           <table className="table table-striped card-body">
                              <thead>
                                 <tr className="category-tr">
                                    <th scope="col" className="text-start ps-4">Sr.No.</th>
                                    <th scope="col" className="text-start ps-4">Order Id</th>
                                    <th scope="col" className="text-start ps-4">Service Image</th>
                                    <th scope="col" className="text-start ps-4">Service Name</th>
                                    <th scope="col" className="text-start ps-4">Quantities</th>
                                    <th scope="col" className="text-start ps-4">Applicable Providers</th>
                                    <th scope="col" className="text-start ps-4">Status</th>
                                    <th scope="col" className="text-start ps-4">Customer Name</th>
                                    <th scope="col" className="text-start ps-4 w-12">Ordered Date</th>
                                    <th scope="col" className="ps-4">Action</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {
                                    orders && orders?.map((data: IServiceOrder, i) => {
                                       // const joinDate = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm A');
                                       const joinDate = formatDiffrentDate(data?.createdAt);
                                       const rowNumber = (pageNo - 1) * pageSize + (i + 1);

                                       return (
                                          <tr key={data?._id}>
                                             <td className="text-start align-content-center ps-4">
                                                <span className="">
                                                   {rowNumber}
                                                </span>

                                             </td>
                                             <td className="text-start align-content-center ps-4">
                                                <span className="">
                                                   {data?.unique_id}
                                                </span>

                                             </td>
                                             <td className="text-start align-content-center ps-4" width={`15%`}>
                                                {data?.serviceDetails?.service_image ?
                                                   <img src={data?.serviceDetails?.service_image} alt="profile-pic" className="profile-pic" />
                                                   :
                                                   <span className="d-flex align-items-center ">
                                                      <img src={profileIcon} alt="profileIcon" className="profile-pic" />
                                                   </span>}
                                             </td>

                                             <td className="text-start align-content-center ps-4">
                                                <span className="">
                                                   {data?.serviceDetails?.title}
                                                </span>
                                             </td>
                                             <td className="text-start align-content-center ps-4">
                                                <span className="">
                                                   {data?.service_count}
                                                </span>
                                             </td>

                                             <td className="text-start align-content-center ps-4">
                                                <span className="">
                                                   {data?.service_providers.length > 0
                                                      ? data?.service_providers.slice(0, 3).join(", ") + (data?.service_providers.length > 3 ? ", ..." : "")
                                                      : data?.service_category === "Engineer"
                                                         ? data?.sub_type
                                                         : data?.service_category}
                                                </span>
                                             </td>


                                             <td className="text-start align-content-center ps-4 ">
                                                <span className={`align-items-center  ${data?.status === "pending" ? "text-danger" : data?.status === "completed" ? "text-success" : "text-warning"}`}
                                                   style={{ fontWeight: 500 }}
                                                >
                                                   {formatCategory(data?.status as string)}
                                                </span> </td>

                                             <td className="icon-td align-content-center text-start ps-4">
                                                {data?.userDetails?.name}
                                             </td>
                                             <td className="icon-td align-content-center text-start ps-4">
                                                {`${joinDate?.formattedDate}, ${joinDate?.formattedHours}`}
                                             </td>
                                             <td className="align-content-center ">
                                                <div className="d-flex justify-content-center gap-3">
                                                   <Link to={`/doorstep-orders/${data?._id}`}>

                                                      <button className="btn btn-sm delete_btn ">
                                                      <img src={eye} />
                                                   </button>
                                                   </Link>
                                                   <button
                                                      className="btn btn-sm delete_btn"
                                                      onClick={() => handleInvoiceClick(data?._id, data?.order_type)}
                                                      style={{ marginBottom: "1px" }}
                                                   >
                                                      <img src={bill} alt="invoice" />
                                                   </button>

                                                </div>

                                             </td>
                                          </tr>
                                       )
                                    }
                                    )
                                 }

                              </tbody>
                           </table>
                        </div>


                        <Paginator
                           totalPages={totalPages}
                           pageNo={pageNo}
                           onPageChange={(e, no) => setPageNo(no)}
                           alignment="right"
                        />
                     </div>


            </div>

         </div>

      </MainLayout>
   )

};



export default DoorstepOrders;